// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import config from '@/config'
import Vue from 'vue'
import App from './App'
import router from './router'
const { $, jQuery } = require('jquery');
global.$ = $;
global.jQuery = jQuery;
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueCookies from 'vue-cookies'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import VueI18n from 'vue-i18n'
import i18n_messages from './i18n'
import QrcodeVue from 'qrcode.vue'
import VModal from 'vue-js-modal'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueSocialSharing from 'vue-social-sharing'


Vue.use(VueSocialSharing);
Vue.use(VModal)
Vue.use(VueReCaptcha, { siteKey: config.google })
Vue.use(Element, { locale })
Vue.use(VueCookies)
Vue.config.productionTip = false
Vue.use(VueSweetalert2);
Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.use(QrcodeVue)
export const i18n = new VueI18n({ locale: 'id', messages:i18n_messages })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js